import React from "react";
import { Helmet } from "react-helmet";

import VangalGallerySection from "../Components/Gallery/VangalGallerySection";
import GalleryStaticBanner from "../Components/Gallery/GalleryStaticBanner";
import PackagesSection from "../Components/Gallery/PackagesSection";

export default function Packages() {
  return (
    <>
      <Helmet>
  <title>Our Infrastructure | Vangal Dairies</title>
  <meta
    name="description"
    content="Discover the state-of-the-art infrastructure of Vangal Dairies, featuring modern processing units, hygienic production facilities, advanced quality testing labs, and efficient cold chain systems ensuring purity and freshness in every product."
  />
</Helmet>
      <GalleryStaticBanner />
      <VangalGallerySection />
      <PackagesSection />
    </>
  );
}
